<template>
  <page>
    <form data-vv-scope="forms">
      <!-- <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-file-document-box</v-icon>
          <v-toolbar-title>Loss of CI Declaration</v-toolbar-title>
        </v-toolbar>
      </v-card> -->
      <v-card>
        <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                          v-model="forms.polNo"
                          :label="labels.polNo"
                          :error-messages="errors.collect('forms.polNo')"
                          data-vv-name="forms.polNo"
                          :data-vv-as="labels.polNo"
                          v-validate="checkPolNo"
                          @input="getPolicyInfo($event)"
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6> </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="forms.comDate"
                          :label="labels.comDate"
                          v-validate="'required'"
                          :data-vv-as="labels.comDate"
                          data-vv-name="forms.comDate"
                          :error-messages="errors.collect('forms.comDate')"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="forms.expiryDate"
                          :label="labels.expiryDate"
                          v-validate="'required'"
                          :data-vv-as="labels.expiryDate"
                          data-vv-name="forms.expiryDate"
                          :error-messages="errors.collect('forms.expiryDate')"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="forms.addrId"
                          :label="labels.addrId"
                          :error-messages="errors.collect('forms.addrId')"
                          data-vv-name="forms.addrId"
                          :data-vv-as="labels.addrId"
                          v-validate="checkAddrId"
                          @input="getInsuredInfo($event)"
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showInsuredHelpList = true" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="forms.vehRegNo"
                          :label="labels.vehRegNo"
                          :error-messages="errors.collect('forms.vehRegNo')"
                          data-vv-name="forms.vehRegNo"
                          :data-vv-as="labels.vehRegNo"
                          v-validate="'required'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="forms.addrName"
                          :label="labels.addrName"
                          :error-messages="errors.collect('forms.addrName')"
                          data-vv-name="forms.addrName"
                          :data-vv-as="labels.addrName"
                          v-validate="'required'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
        <v-expansion-panels v-model="panel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Address</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="forms.addr1"
                          :label="labels.addr1"
                          :error-messages="errors.collect('forms.addr1')"
                          data-vv-name="forms.addr1"
                          :data-vv-as="labels.addr1"
                          v-validate="'required'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="forms.addr2"
                          :label="labels.addr2"
                          :error-messages="errors.collect('forms.addr2')"
                          data-vv-name="forms.addr2"
                          :data-vv-as="labels.addr2"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="forms.addr3"
                          :label="labels.addr3"
                          :error-messages="errors.collect('forms.addr3')"
                          data-vv-name="forms.addr3"
                          :data-vv-as="labels.addr3"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="forms.addr4"
                          :label="labels.addr4"
                          :error-messages="errors.collect('forms.addr4')"
                          data-vv-name="forms.addr4"
                          :data-vv-as="labels.addr4"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-model="forms.freeTxt"
                          :label="labels.freeTxt"
                          no-resize
                          rows="3"
                          :error-messages="errors.collect('forms.freeTxt')"
                          data-vv-name="forms.freeTxt"
                          :data-vv-as="labels.freeTxt"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
        <v-icon left dark>mdi-file-export</v-icon>
        Export To
      </v-btn>
      <v-btn-toggle dense mandatory v-model="forms.format">
        <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
          <span>{{ format.label }}</span>
          <v-icon :color="format.color">{{ format.icon }}</v-icon>
        </v-btn>
      </v-btn-toggle>
    </form>
    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list4
        :boolPolRefresh="showPolicyHelpList"
        @close="showPolicyHelpList = false"
        @assign-policy-info="assignPolicyInfo"
      ></policy-help-list4>
    </v-dialog>
    <v-dialog v-model="showInsuredHelpList" width="1280px">
      <insured-help-list headerInfo="headers1" @close="showInsuredHelpList = false" @assign-insured-info="assignInsuredInfo"></insured-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import PolicyHelpList4 from '@/components/core/common/dialog/PolicyHelpList4'
import InsuredHelpList from '@/components/core/common/dialog/InsuredHelpList'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        comDate: 'Commencement Date',
        expiryDate: 'Expiry Date',
        addrId: 'Addressee ID',
        vehRegNo: 'Vehicle Registration No.',
        addrName: 'Addressee Name',
        addr1: 'Address 1',
        addr2: 'Address 2',
        addr3: 'Address 3',
        addr4: 'Address 4',
        freeTxt: 'Free Text',
        format: ''
      },
      forms: {
        polNo: '',
        comDate: '',
        expiryDate: '',
        addrId: '',
        vehRegNo: '',
        addrName: '',
        addr1: '',
        addr2: '',
        addr3: '',
        addr4: '',
        freeTxt: '',
        format: ''
      },
      showPolicyHelpList: false,
      showInsuredHelpList: false,
      submitting: false,
      menu: {},
      supportedFormat: [],
      valPolNo: false,
      valAddrId: false,
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initLossCiDeclaration
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {

      }
    },
    doExport() {
      this.$validator.validateAll('forms').then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.forms)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getPolicyInfo(polNo) {
      this.valPolNo = false
      this.forms.addr1 = ''
      this.forms.addr2 = ''
      this.forms.addr3 = ''
      this.forms.addr4 = ''
      this.forms.addrName = ''
      this.forms.vehRegNo = ''
      const apiUrl = this.menu.getPolicyInfo
      if (apiUrl) {
        try {
          const expand = {
            polNo: polNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.polMaster.polNo !== null) {
              this.valPolNo = true
              this.assignPolicyInfo(data.polMaster)
            }
          }
        } catch (err) {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getInsuredInfo(addrId) {
      this.valAddrId = false
      const apiUrl = this.menu.getInsuredInfo
      if (apiUrl) {
        try {
          const expand = {
            addrId: addrId
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.insured.insdRefNo !== null) {
              this.valAddrId = true
              this.assignInsuredInfo(data.insured)
            }
          }
        } catch (err) {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicyInfo(data) {
      let name = ''
      this.forms.polNo = data.polNo
      this.forms.addr1 = data.insdAddr1
      this.forms.addr2 = data.insdAddr2
      this.forms.addr3 = data.insdAddr3
      this.forms.addr4 = data.insdAddr4

      if (this.forms.addr4 !== null && this.forms.addr4 !== '') {
        this.forms.addr4 = this.forms.addr4 + ' ' + data.postCode
      } else if (this.forms.addr3 !== null && this.forms.addr3 !== '') {
        this.forms.addr3 = this.forms.addr3 + ' ' + data.postCode
      } else if (this.forms.addr2 !== null && this.forms.addr2 !== '') {
        this.forms.addr2 = this.forms.addr2 + ' ' + data.postCode
      } else if (this.forms.addr1 !== null && this.forms.addr1 !== '') {
        this.forms.addr1 = this.forms.addr1 + ' ' + data.postCode
      }
      if (data.insdName1 !== null) {
        name = data.insdName1
      }
      if (data.insdName2 !== null) {
        name = name + ' ' + data.insdName2
      }
      if (data.insdName3 !== null) {
        name = name + ' ' + data.insdName3
      }
      if (data.insdName4 !== null) {
        name = name + ' ' + data.insdName4
      }
      this.forms.addrName = name
      this.valPolNo = true
      this.getVehRegNo(data.polNo)
    },
    async getVehRegNo(polNo) {
      const apiUrl = this.menu.getLatestVehRegNo
      if (apiUrl) {
        try {
          const expand = {
            polNo: polNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.forms.vehRegNo = data
          }
        } catch (err) {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignInsuredInfo(data) {
      this.forms.addrId = data.insdRefNo
      this.forms.addr1 = data.address1
      this.forms.addr2 = data.address2
      this.forms.addr3 = data.address3
      this.forms.addr4 = data.address4
      this.valAddrId = true

      if (this.forms.addr4 !== null && this.forms.addr4 !== '') {
        this.forms.addr4 = this.forms.addr4 + ' ' + data.postalCode
      } else if (this.forms.addr3 !== null && this.forms.addr3 !== '') {
        this.forms.addr3 = this.forms.addr3 + ' ' + data.postalCode
      } else if (this.forms.addr2 !== null && this.forms.addr2 !== '') {
        this.forms.addr2 = this.forms.addr2 + ' ' + data.postalCode
      } else if (this.forms.addr1 !== null && this.forms.addr1 !== '') {
        this.forms.addr1 = this.forms.addr1 + ' ' + data.postalCode
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    checkPolNo() {
      if ((this.forms.polNo !== null || this.forms.polNo !== '') && this.valPolNo === false) {
        return 'required|valPol:' + this.valPolNo
      } else {
        return 'required'
      }
    },
    checkAddrId() {
      if ((this.forms.addrId !== null || this.forms.addrId !== '') && this.valAddrId === false) {
        return 'entry|valAddrId:' + this.valAddrId
      } else {
        return ''
      }
    }
  },
  created() {
    this.$validator.extend('valPol', {
      getMessage(field, args) {
        return 'Invalid Policy No.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isPolNoExist = args[0]
        if (isPolNoExist === false) {
          return true
        } else {
          return false
        }
      }
    })
    this.$validator.extend('valAddrId', {
      getMessage(field, args) {
        return 'Invalid Addressee ID'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isAddrIdExist = args[0]
        if (isAddrIdExist === false) {
          return true
        } else {
          return false
        }
      }
    })
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        this.forms.format = value[0].value
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    PolicyHelpList4,
    InsuredHelpList
  }
}
</script>
